import type { MaterialCategory, ShapeKind } from "@/features/materials/types";

export const MATERIAL_CATEGORIES: { value: MaterialCategory; label: string }[] = [
  { value: "raw", label: "Raw" },
  { value: "intermediate", label: "Intermediate" },
  { value: "finished", label: "Finished" },
  { value: "traded", label: "Traded" },
];

export const SHAPE_KINDS: { value: ShapeKind; label: string }[] = [
  { value: "round", label: "Round" },
  { value: "square", label: "Square" },
  { value: "rectangle", label: "Rectangle" },
  { value: "oval", label: "Oval" },
  { value: "ellipse", label: "Ellipse" },
  { value: "capsule", label: "Capsule" },
  { value: "custom", label: "Custom" },
];

/** Shapes offered on PO / receive for tube & CTL (from v1 catalogue) */
export const TUBE_ORDER_SHAPES: { value: ShapeKind; label: string }[] = [
  { value: "round", label: "Round" },
  { value: "square", label: "Square" },
  { value: "rectangle", label: "Rectangle" },
  { value: "oval", label: "Oval" },
  { value: "custom", label: "Custom / D" },
];

export function formatShapeSizeLabel(row: {
  size_label?: string | null;
  shape?: string | null;
  od?: number | null;
  thickness?: number | null;
  width?: number | null;
  mother?: { size_label?: string | null } | null;
}) {
  const base = row.size_label?.trim() || "Size";
  const bits: string[] = [base];
  if (row.shape === "round" || row.shape == null) {
    return bits.join(" · ");
  }

  const mother = row.mother?.size_label?.trim();
  if (mother) {
    // Prefer mother size; only add Ø when it differs from the mother label
    // (e.g. mother "18.5" with OD 19.05) — avoids "Ø50.8 · ← 50.8"
    bits.push(`← ${mother}`);
    const motherNum = Number(mother);
    if (
      row.od != null &&
      (!Number.isFinite(motherNum) || Math.abs(motherNum - Number(row.od)) > 0.011)
    ) {
      bits.push(`Ø${row.od}`);
    }
  } else if (row.od != null) {
    bits.push(`Ø${row.od}`);
  }
  return bits.join(" · ");
}

export function labelFor<T extends string>(
  options: { value: T; label: string }[],
  value: T | string | null | undefined,
) {
  if (!value) return "—";
  return options.find((o) => o.value === value)?.label ?? value;
}
